import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export interface AllowedEmailsContextType {
  openAllowedEmails: () => void;
  closeAllowedEmails: () => void;
}

const AllowedEmailsContext = createContext<AllowedEmailsContextType | undefined>(undefined);

export function useAllowedEmails(): AllowedEmailsContextType {
  const ctx = useContext(AllowedEmailsContext);
  if (!ctx) {
    throw new Error('useAllowedEmails must be used within AllowedEmailsProvider');
  }
  return ctx;
}

interface AllowedEmailsProviderProps {
  children: ReactNode;
}

export function AllowedEmailsProvider({ children }: AllowedEmailsProviderProps) {
  const [, setIsOpen] = useState(false);

  const openAllowedEmails = useCallback(() => {
    setIsOpen(true);
    // v2 uses full page at /v2/email-access instead of modal
  }, []);

  const closeAllowedEmails = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value: AllowedEmailsContextType = {
    openAllowedEmails,
    closeAllowedEmails
  };

  return (
    <AllowedEmailsContext.Provider value={value}>
      {children}
    </AllowedEmailsContext.Provider>
  );
}
